import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import "./config/i18n";
import AppWithProviders from "./AppWithProviders.jsx";

// Recover from stale cached HTML pointing at missing hashed chunks.
// This happens after a deployment when the browser loads an older index.html.
window.addEventListener("vite:preloadError", () => {
  const key = "vite:preloadError:reloaded";
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <AppWithProviders />
);
